import Vue from 'vue'
import IdleVue from 'idle-vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import currency from "@/utils/currency.js";
import * as dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale('es')


Vue.config.productionTip = false


axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

const eventsHub = new Vue()
 
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 540000 // Establecemos en 9 minutos de inactividad
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


Vue.filter('formatdate', function (value) {
  if (!value) return ''
      value = dayjs(value).format('DD/MM/YYYY')
      return value;
})

Vue.filter('currency', function (value) {
  if (!value) return 0.00
      value = currency(value, {precision:2, separator: ',',symbol:'Q'}).format();
      return value;
})